var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM13.9082 4.24431C13.357 3.37902 12.621 2.64296 11.7557 2.09177L10.4731 3.65345C11.2531 4.09822 11.9018 4.7469 12.3465 5.52692L13.9082 4.24431ZM4.24431 2.09177L5.52692 3.65345C4.7469 4.09822 4.09822 4.7469 3.65345 5.52692L2.09177 4.24431C2.64296 3.37902 3.37902 2.64296 4.24431 2.09177ZM2.09177 11.7557L3.65345 10.4731C4.09822 11.2531 4.7469 11.9018 5.52692 12.3465L4.24431 13.9082C3.37902 13.357 2.64296 12.621 2.09177 11.7557ZM11.7557 13.9082L10.4731 12.3465C11.2531 11.9018 11.9018 11.2531 12.3465 10.4731L13.9082 11.7557C13.357 12.621 12.621 13.357 11.7557 13.9082ZM12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f89bec2292032c1c00c5cfcc44e7ae8a.svg";
export { ForwardRef as ReactComponent };